import BrandSearchCarouselPage from "@faire/prototype-playground/workspace/qb/brand-search-carousel";
import JourneyAwarePdpPage from "@faire/prototype-playground/workspace/qb/journey-aware-pdp";
import ReorderHubReorderBuildingByBrandPage from "@faire/prototype-playground/workspace/qb/reorder-building-by-brand";
import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";

const BrandPageSamplesPlacementPage = withCompass(
  () =>
    import("@faire/prototype-playground/workspace/qb/brand-page-samples-placement/Page")
);

export function QuinnBudanRoutes() {
  return (
    <Switch>
      <Route
        path="/qb/brand-page-samples-placement"
        component={BrandPageSamplesPlacementPage}
      />
      <Route
        path="/qb/brand-search-carousel"
        component={BrandSearchCarouselPage}
      />
      <Route path="/qb/journey-aware-pdp" component={JourneyAwarePdpPage} />
      <Route
        path="/qb/reorder-building-by-brand"
        component={ReorderHubReorderBuildingByBrandPage}
      />
    </Switch>
  );
}

export const slug = "qb";
